import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  inject,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { globalMessages } from '../../global-message';
import { ResponsiveService } from '../../services/responsive.service';
import { FormsModule } from '@angular/forms';
import { StepUpAuthService } from '../../services/step-up-auth.service';
import { APP_CONFIG, AppConfig } from '../../../../app.config';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  globalMessage = globalMessages;
  private readonly responsive = inject(ResponsiveService);
  private readonly stepUpAuth = inject(StepUpAuthService);
  private readonly router = inject(Router);
  isProduction: boolean = true;

  readonly isDesktop = toSignal(this.responsive.isDesktop$, { initialValue: true });
  readonly isMobile = toSignal(this.responsive.isMobile$, { initialValue: true });

  @Output() themeChange = new EventEmitter<string>();
  defaultTheme: string = 'psic';
  themes: Array<{ value: string; label: string }> = [
    { value: 'psic', label: 'PSIC Theme' },
    { value: 'red', label: 'Red Theme' },
    { value: 'neutral', label: 'Neutral Theme' },
    { value: 'blue', label: 'Blue Theme' },
    { value: 'green', label: 'Green Theme' },
    { value: 'dark', label: 'Dark Theme' },
  ];

  constructor(@Inject(APP_CONFIG) private config: AppConfig) {
    this.isProduction = this.config.production || false;
    const storedTheme = localStorage.getItem('selectedTheme');
    if (storedTheme) {
      this.defaultTheme = storedTheme;
    }
  }

  onThemeChange(event: Event) {
    const selectedTheme = (event.target as HTMLSelectElement).value;
    localStorage.setItem('selectedTheme', selectedTheme);
    this.themeChange.emit(selectedTheme);
  }
  readonly isAuthenticated = this.stepUpAuth.isAuthenticated;

  goToHome(): void {
    window.location.href = '/';
  }

  signOut(): void {
    this.stepUpAuth.clearAuth();
    this.router.navigate([globalMessages.routeSignIn]);
  }
}
